import request from '@/utils/service'

export function getAdminList(data) {
  return request({ url: '/mgr/list', data })
}

export function updateAdmin(data, status) {
  const url = status === 'create' ? '/mgr/add' : '/mgr/update'
  return request({ url, method: 'post', data })
}

export function freezeAdmin(code, bool) {
  const url = bool ? '/mgr/freeze' : '/mgr/unfreeze'
  return request({ url, method: 'post', data: { code } })
}

export function deleteAdmin(code) {
  return request({ url: '/mgr/delete', method: 'get', params: { code } })
}

export function getRoleList(data) {
  return request({ url: '/role/list', method: 'post', data })
}

export function updateRole(data, status) {
  const url = status === 'create' ? '/role/add' : '/role/update'
  return request({ url, method: 'post', data })
}

export function deleteRole(code) {
  return request({ url: '/role/delete', method: 'get', params: { code } })
}

export function updateRoleMenu(data) {
  return request({ url: '/role/setAuthority', method: 'post', data })
}

export function getRoleMenu(id) {
  return request({ url: `/menu/menuTreeListByRoleId/${id}`, method: 'post' })
}
